import { Badge } from 'antd';
import { PropsWithChildren } from 'react';

import { BlueOutlineButton } from '@components';
import cls from './DownloadBlock.module.css';

interface Props {
  title: string;
  onClick: () => void;
  isLoading: boolean;
  counter?: number;
}

const Icon = () => {
  return (
    <svg className={cls.icon} width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className={cls.iconPath} fill="var(--primary-color)" d="M16 0C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 1.28855e-07 20.4183 0 16V8C0 3.58172 3.58172 1.28851e-07 8 0H16ZM12.0195 5.00098C11.4147 5.02287 10.9419 5.55259 10.9629 6.18359V15.6709L8.82129 13.6826C8.36967 13.263 7.67812 13.3046 7.27637 13.7764C6.87462 14.2481 6.91558 14.971 7.36719 15.3906L10.585 18.3955C10.9483 18.76 11.4262 18.9745 11.9297 18.998C11.9679 19.0003 12.0067 19.0003 12.0449 18.998C12.089 18.9973 12.1337 18.9943 12.1777 18.9883C12.6805 18.955 13.1539 18.7326 13.5107 18.3613L16.6758 15.0645H16.6768C17.1052 14.6199 17.1082 13.8956 16.6826 13.4473C16.257 12.9991 15.5639 12.9969 15.1348 13.4414L13.1514 15.5137V6.10449C13.1304 5.4729 12.6234 4.97936 12.0195 5.00098Z"/>
    </svg>
  );
};

const IconLoad = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
    >
      <g>
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 12 12"
          to="360 12 12"
          dur="1s"
          repeatCount="indefinite"
        />

        <path
          fill="#042E6B"
          d="M6.804 15a1 1 0 0 0-1.366-.366l-1.732 1a1 1 0 0 0 1 1.732l1.732-1A1 1 0 0 0 6.804 15ZM3.706 8.366l1.732 1a1 1 0 1 0 1-1.732l-1.732-1a1 1 0 0 0-1 1.732ZM6 12a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1Zm11.196-3a1 1 0 0 0 1.366.366l1.732-1a1 1 0 1 0-1-1.732l-1.732 1A1 1 0 0 0 17.196 9ZM15 6.804a1 1 0 0 0 1.366-.366l1-1.732a1 1 0 1 0-1.732-1l-1 1.732A1 1 0 0 0 15 6.804Zm5.294 8.83-1.732-1a1 1 0 1 0-1 1.732l1.732 1a1 1 0 0 0 1-1.732Zm-3.928 1.928a1 1 0 1 0-1.732 1l1 1.732a1 1 0 1 0 1.732-1ZM21 11h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2Zm-9 7a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1Zm-3-.804a1 1 0 0 0-1.366.366l-1 1.732a1 1 0 0 0 1.732 1l1-1.732A1 1 0 0 0 9 17.196ZM12 2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Z"
        />
      </g>
    </svg>
  );
};

export const DownloadBlock = (
  { title, onClick, isLoading, counter, children }: PropsWithChildren<Props>,
) => {
  return (
    <div className={cls.block}>
      <div className={cls.title}>
        {counter !== undefined ? (
          <Badge className={cls.badge} count={counter} showZero color="var(--primary-color)">
            <span className={cls.titleText}>{title}</span>
          </Badge>
        ) : <span className={cls.titleText}>{title}</span>}
      </div>
      <div className={cls.actions}>
        {children ? children : (
          <BlueOutlineButton
            className={cls.action}
            onClick={onClick}
            disabled={isLoading || counter === 0}
          >
            {isLoading ? <IconLoad/> : <Icon />}
          </BlueOutlineButton>
        )}
      </div>
    </div>
  );
};
